module.exports = __webpack_public_path__ + "img/Celloger Nano_2.739f3ddd.png";